var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsTextSubmit = function SvgMillustrationsTextSubmit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 13,
    x: 6.5,
    y: 13.5,
    fill: "#fff",
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 4,
    x: 10,
    y: 18,
    fill: "#CCCCD9",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 8,
    x: 22,
    y: 16,
    fill: "#8A8A99",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 13,
    x: 6.5,
    y: 13.5,
    stroke: "#B6B2FF",
    rx: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    x: 38.5,
    y: 13.5,
    fill: "#B6B2FF",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8884C8",
    d: "M43.707 17.293a1 1 0 0 0-1.414 1.414zM45 20l.707.707a1 1 0 0 0 0-1.414zm-2.707 1.293a1 1 0 0 0 1.414 1.414zm0-2.586 2 2 1.414-1.414-2-2zm2 .586-2 2 1.414 1.414 2-2z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    x: 38.5,
    y: 13.5,
    stroke: "#A39FEF",
    rx: 1.5
  })));
};
export default SvgMillustrationsTextSubmit;